import { CapacitorCookies } from '@capacitor/core'

class Cookie {

    static async set(name, value, days = 365) {
        const stringValue = String(value);

        //& Electron case
        if (window.electronAPI) return await window.electronAPI.setCookie(name, stringValue, days);

        //& Calculate expiry date
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

        //& Browser cookie
        document.cookie = `${name}=${encodeURIComponent(stringValue)}; Max-Age=${days * 24 * 60 * 60}; path=/`;

        //& Capacitor (if available)
        if (typeof CapacitorCookies !== "undefined") {
            return await CapacitorCookies.setCookie({
                key: name,
                value: stringValue,
                expires: expires.toUTCString(),
                path: '/',
            });
        }
    }

    static async get(name) {
        //& Electron
        if (window.electronAPI) {
            return await window.electronAPI.getCookie(name);
        }

        //& Capacitor
        if (typeof CapacitorCookies !== "undefined") {
            const cookies = await CapacitorCookies.getCookies();
            return cookies[name];
        }

        //& Fallback (browser)
        const nameEQ = `${name}=`;
        const cookies = document.cookie.split(';');

        for (let c of cookies) {
            c = c.trim();
            if (c.startsWith(nameEQ)) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }

        return null;
    }

    static async erase(name) {
        //& Electron
        if (window.electronAPI) {
            return await window.electronAPI.deleteCookie(name);
        }

        //& Capacitor
        if (typeof CapacitorCookies !== "undefined") {
            await CapacitorCookies.deleteCookie({
                key: name,
                path: '/',
            });
        }

        //& Browser fallback
        document.cookie = `${name}=; Max-Age=0; path=/`;
    }

    static async clearAll() {
        //& Electron
        if (window.electronAPI) {
            return await window.electronAPI.clearCookies();
        }

        //& Capacitor
        if (typeof CapacitorCookies !== "undefined") {
            await CapacitorCookies.clearCookies();
        }

        //& Browser fallback
        const cookies = document.cookie.split(';');

        for (const cookie of cookies) {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1
                ? cookie.substring(0, eqPos).trim()
                : cookie.trim();

            document.cookie = `${name}=; Max-Age=0; path=/`;
        }
    }
}

export default Cookie;
